import { repairMojibake } from 'app/core/utils/repair-mojibake';

export const locale = repairMojibake({
  lang: 'ar',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "لوحة التحكم",
        BADGE: "2",
        ANALYTICS: "الإحصائيات",
        ECOMMERCE: "التجارة الإلكترونية",
        "HOME": "الرئيسية ",
        "SAMPLE": "عينة ",
        "users": "المستخدمين",
        "list": "القائمة",
        "add": "إضافة",
        "ads": "الإعلانات",
        "counselors": "المستشارين",
        "stores_offers": "عروض المتاجر",
        "cancelation_reason": "سبب الإلغاء",
        "companies": "الشركات",
        "consulting": "الاستشارات",
        "categories": "الفئات",
        "services": "الخدمات",
        "tags": "العلامات",
        "articles": "المقالات",
        "offers": "العروض",
        "plantcards": "بطاقات النباتات",
        "Settings": "الإعدادات",
        "ShowDetails": "عرض التفاصيل",
        "TermsAndConditions": "الشروط والأحكام",
        "About": "حول",
        "Notifications": "الإشعارات",
        "Currencies": "العملات",
        "Countries": "الدول",
        "Cities": "المدن",
        "plans": "الخطط",
        "light": "الضوء",
        "root": "الجذر",
        "seed": "البذرة",
        "soil": "التربة",
        "stem": "الجذع",
        "counselorspayment": "دفع المستشارين",
        "OpenScreens": "الشاشات المفتوحة",
        "GanatakCommunity": "مجتمع جانتاك",
        "Paperform": "نموذج الورقة",
        "Sizes": "الأحجام",
        "Sliders": "المنزلقات"
      },
      ANMAR: {
        TITLE: "أنمار",
        HOME_DETAILS: " الرئيسية",
        HOME_ABOUT: "نبذة عنا ",
        HOME_SERVICES: "الخدمات ",
        HOME_WORK: "أعمالنا",
        HOME_BUSINESS: "أشغال",
        HOME_CLIENTS: "عملاؤنا",
        HOME_PARTNERS: "شركاؤنا",
        ABOUT_DATES: "تواريخ من نحن",
        ABOUT_VISION: "الرؤية",
        ABOUT_VALUE: "القيم",
        ABOUT_TEAM: "الفريق",
        SERVICES_STEPS: "خطوات الخدمات",
        CONTACT_MESSAGES: "الرسائل ",
        BLOG: "المدونة",
        LIST: "القائمة",
        ADD: "إضافة",
        SERVICES: "الخدمات",
        PROJECTS: "المشاريع",
        COMPANY_PROFILES: "ملفات الشركة",
        SECTIONS: "أقسام الموقع"
      },
      USERS_SECTION: "العملاء",
      USERS: {
        LIST: "قائمة المستخدمين",
        ADD: "إضافة مستخدم"
      },
      PRODUCTS: {
        Title: "المنتجات",
        LIST: "قائمة المنتجات",
        AT_HOME: "منتجات في المنزل"
      },
      COUNSELORS: {
        Title: "المستشارين",
        LIST: "قائمة الاستشاريين",
        ADD: "إضافة استشاري"
      },
      STORES: {
        Title: "المتاجر",
        LIST: "قائمة المتاجر",
        ADD: "إضافة متجر"
      },
      STORES_OFFERS: {
        Title: "عروض المتاجر",
        LIST: "قائمة العروض"
      },
      VOUCHER: {
        Title: "العروض الترويجية",
        TYPE: "أنواع العروض الترويجية",
        LIST: "قائمة العروض الترويجية"
      },
      cancelation_reasons: {
        Title: "سبب الالغاء",
        LIST: "قائمة أسباب الإلغاء",
        ADD: "إضافة سبب"
      },
      COMPANIES: {
        Title: "الشركات",
        LIST: "قائمة الشركات",
        ARCHIVED: "الشركات المؤرشفة",
        "ADD": "إضافة شركة"
      },
      consulting: {
        Title: "الاستشارات",
        LIST: "قائمة الاستشارات"
      },
      SERVICES: {
        Title: "الخدمات",
        LIST: "قائمة الخدمات",
        ADD: "إضافة خدمة"
      },
      SECTION: {
        Title: "الاقسام",
        LIST: "قائمة الاقسام",
        TYPES: "انواع القسائم",
        ADD: "إضافة قسم"
      },
      ARTICLES: {
        Title: "المقالات",
        LIST: "قائمة المقالات",
        Plant_groups: "المجموعات النباتية",
        ADD: "إضافة ",
        various: "مقالات زراعية متنوعة"
      },
      TAGS: {
        Title: "التاجات",
        LIST: "قائمة التاجات",
        ADD: "إضافة علامة"
      },
      offers: {
        Title: "العروض",
        LIST: "قائمة العروض",
        ADD: "إضافة عروض"
      },
      reasone_canceled: {
        Title: "سبب الالغاء",
        LIST: "قائمة ",
        ADD: "إضافة"
      },
      PLANTCARDS: {
        TITLE: "بطاقات النباتات",
        LIST: "قائمة بطاقات النباتات",
        ADD: "إضافة بطاقة نبات",
        LEAVERSCOLOR: {
          TITLE: "ألوان أوراق النباتات",
          LIST: "قائمة ألوان أوراق النباتات",
          ADD: "إضافة لون لأوراق النباتات"
        },
        LEAVERSFORM: {
          TITLE: "أشكال أوراق النباتات",
          LIST: "قائمة أشكال أوراق النباتات",
          ADD: "إضافة شكل لأوراق النباتات"
        },
        FLOWERFORM: {
          TITLE: "أشكال الأزهار",
          LIST: "قائمة أشكال الأزهار",
          ADD: "إضافة شكل للأزهار"
        },
        FLOWERCOLOR: {
          TITLE: "ألوان الأزهار",
          LIST: "قائمة ألوان الأزهار",
          ADD: "إضافة لون للأزهار"
        },
        ENVIRONMENTLIGHT: {
          TITLE: "إضاءة البيئة",
          LIST: "قائمة إضاءة البيئة",
          ADD: "إضافة إضاءة بيئة"
        },
        ENVIRONMENTTEMP: {
          TITLE: "درجة حرارة البيئة",
          LIST: "قائمة درجات حرارة البيئة",
          ADD: "إضافة درجة حرارة بيئة"
        },
        ENVIRONMENHUMIDITY: {
          TITLE: "رطوبة البيئة",
          LIST: "قائمة رطوبة البيئة",
          ADD: "إضافة رطوبة بيئة"
        },
        REPRODUCTIONS: {
          TITLE: "التكاثر",
          LIST: "قائمة طرق التكاثر",
          ADD: "إضافة طريقة تكاثر"
        },
        PLANTCARDSOIL: {
          TITLE: "أنواع التربة",
          LIST: "قائمة أنواع التربة",
          ADD: "إضافة نوع تربة"
        }
      }
    },
    ANMAR_PAGES: {
      COMMON: {
        LIST: "القائمة",
        ADD: "إضافة",
        EDIT: "تعديل",
        VIEW: "عرض",
        DELETE: "حذف",
        SAVE: "حفظ",
        UPDATE: "تحديث",
        CANCEL: "إلغاء",
        ACTIONS: "الإجراءات",
        LOADING: "جاري التحميل...",
        NO_DATA: "لا توجد بيانات",
        CONFIRM_DELETE: "هل أنت متأكد من حذف هذا العنصر؟",
        CREATED_SUCCESS: "تمت الإضافة بنجاح",
        UPDATED_SUCCESS: "تم التحديث بنجاح",
        DELETED_SUCCESS: "تم الحذف بنجاح",
        ERROR: "حدث خطأ ما",
        ACTIVE: "نشط",
        INACTIVE: "غير نشط",
        YES: "نعم",
        NO: "لا",
        SEARCH: "بحث",
        SHOW: "عرض",
        ENTRIES: "عناصر",
        EMPTY_HELP: "جرّب إضافة عنصر جديد أو تغيير نص البحث.",
        CREATE_ENTRY: "إضافة عنصر جديد",
        UPDATE_ENTRY: "تحديث البيانات الحالية",
        ARRAY_HINT: "أدخل القيم مفصولة بفواصل وسيتم إرسالها كمصفوفة.",
        REQUIRED_FIELD: "يرجى تعبئة الحقول المطلوبة"
      },
      FIELDS: {
        ID: "المعرف",
        IMAGE: "الصورة",
        ICON: "الأيقونة",
        VIDEO: "الفيديو",
        LINK: "الرابط",
        TITLE_AR: "العنوان بالعربية",
        TITLE_EN: "العنوان بالإنجليزية",
        DESCRIPTION_AR: "الوصف بالعربية",
        DESCRIPTION_EN: "الوصف بالإنجليزية",
        SHORT_DESCRIPTION_AR: "الوصف المختصر بالعربية",
        SHORT_DESCRIPTION_EN: "الوصف المختصر بالإنجليزية",
        CONTENT_AR: "المحتوى بالعربية",
        CONTENT_EN: "المحتوى بالإنجليزية",
        NAME: "الاسم",
        NAME_AR: "الاسم بالعربية",
        NAME_EN: "الاسم بالإنجليزية",
        EMAIL: "البريد الإلكتروني",
        TYPE: "النوع",
        ABOUT: "الموضوع",
        STATUS: "الحالة",
        VALUE: "القيمة",
        KEY: "المفتاح",
        SLUG: "الرابط المختصر",
        LOCATION_AR: "الموقع بالعربية",
        LOCATION_EN: "الموقع بالإنجليزية",
        PROJECT_URL: "رابط المشروع",
        PAGE_ID: "معرف الصفحة",
        SUBTITLE_AR: "العنوان الفرعي بالعربية",
        SUBTITLE_EN: "العنوان الفرعي بالإنجليزية",
        DATE: "التاريخ",
        YEAR: "السنة",
        CATEGORY: "التصنيف",
        CATEGORIES: "التصنيفات",
        LANGUAGES: "اللغات",
        PROGRAMMING_LANGUAGES: "لغات البرمجة",
        WEBSITE_URL: "رابط الموقع",
        WEBSITE_LINK: "رابط الموقع",
        ANDROID_LINK: "رابط أندرويد",
        IOS_LINK: "رابط iOS",
        STEPS: "الخطوات",
        STEP: "خطوة",
        STEP_NUMBER: "رقم الخطوة",
        ADD_STEP: "إضافة خطوة",
        REMOVE_STEP: "حذف خطوة",
        STEP_TITLE_AR: "عنوان الخطوة بالعربي",
        STEP_TITLE_EN: "عنوان الخطوة بالإنجليزي",
        STEP_DESCRIPTION_AR: "وصف الخطوة بالعربي",
        STEP_DESCRIPTION_EN: "وصف الخطوة بالإنجليزي",
        STEPS_COUNT: "عدد الخطوات",
        STEPS_HELP: "أضف خطوات خاصة بكل مشروع ضمن هذا العنصر.",
        SORT_ORDER: "ترتيب العرض",
        IS_ACTIVE: "نشط",
        CLIENT_NAME: "اسم العميل",
        IS_FEATURED: "مشروع مميز"
      },
      MODULES: {
        HOME_DETAILS: "تفاصيل الرئيسية",
        HOME_ABOUT: "نبذة الرئيسية",
        HOME_SERVICES: "خدمات الرئيسية",
        HOME_WORK: "أعمال الرئيسية",
        HOME_BUSINESS: "أشغال",
        HOME_CLIENTS: "عملاء الرئيسية",
        HOME_PARTNERS: "شركاء الرئيسية",
        ABOUT_DATES: "تواريخ من نحن",
        ABOUT_VISION: "الرؤية",
        ABOUT_VALUE: "القيم",
        ABOUT_TEAM: "الفريق",
        SERVICES_STEPS: "خطوات الخدمات",
        CONTACT_MESSAGES: "رسائل التواصل",
        BLOG: "المدونة",
        SERVICES: "الخدمات",
        PROJECTS: "المشاريع",
        COMPANY_PROFILES: "ملفات الشركة PDF",
        SECTIONS: "أقسام الصفحات"
      }
    }
  }
});
